import gql from "graphql-tag";

export const changeBreadcrumbsMetaMutation = gql`
	mutation($label: String, $id: String) {
		changeBreadcrumbsMetaMutation(label: $label, id: $id) @client
	}
`;

export const changeBreadcrumbsMetaMutation2 = gql`
	mutation($label: String, $label2: String, $id: String, $id2: String) {
		changeBreadcrumbsMetaMutation(label: $label, label2: $label2, id: $id, id2: $id2) @client
	}
`;

export const clearBreadcrumbsMetaMutation = gql`
	mutation {
		clearBreadcrumbsMetaMutation @client
	}
`;

export const breadcrumbsQuery = gql`
	{
		breadcrumbsMeta @client {
			label
			label2
			label3
			id
			id2
			id3
		}
	}
`;

export default {
	breadcrumbsQuery
};



// WEBPACK FOOTER //
// ./src/graphql/breadcrumbsMeta/queries.js